/**
 * Allows interaction with the Customer's Canvas API (this is the built-in web service - not our custom node service).
 */

 import {cs} from "../../../react/chain-services";
 import {Fetcher} from "../../../utils/browser/fetcher";

 export const CcDirectApis3 = ({host, userId, tokenId}) => cs(
    ["fetcher", (_, next) => next(Fetcher({
        host,
        headers: {
            "X-CCToken": tokenId,
        },
    }))],
    ({fetcher: {postJson, getJson, putJson, deleteJson}}) => ({

        // loads all user image gallery folders
        /* returns data in the following format:
            {   total:     int - Number of items
                page:      int - Current page - Starts at 0
                pageSize:  int - Items per page
                folders:   array [ {
                    name:       string - Folder name
                    date:       datetime - Creation date
                    path:       ? - Always returns null in current testing
                    fileCount:  int - Number of images in the gallery
                } ]
            }
        */
        getImageGalleryCategories: async () => await getJson(
            "/api/Gallery/Private/" + userId + "/folders",
            true
        ),

        // loads all user image gallery images for a given folder - if no folder provided, will pull from the base level
        /* returns data in the following format:
            {   success:    bool
                total:      int - Num images
                totalPages: int - 
                page:       int - Current page - Starts at 0
                nextPage:   int - Will be -1 if no next page
                pageSize:   int - Items per page
                items:      array [ {
                    storageId:      string
                    name:           string - File name
                    path:           string - CC reference - Can be used directly for inserting in an image area
                    width:          int - Pixel width
                    height:         int - Pixel height
                    dateCreated:    datetime
                    editingEnabled: bool
                    isUserImage:    bool
                    isVector:       bool
                    originalUrl:    string - HTTP path to download - Need to add X-CCToken URL param if want to use - Example value: https://ds-dev.xpressdocs.com/api/Gallery/Private/4e1ef77b-d0d7-426f-b2cc-c6597e8f9d70/files/download/IMG_20190921_091857.jpg
                    previewUrl:     ? - Always returns null in current testing
                    deleteUrl:      string - HTTP path to view, update, or delete image - Example value: https://ds-dev.xpressdocs.com/api/Gallery/Private/4e1ef77b-d0d7-426f-b2cc-c6597e8f9d70/files/IMG_20190921_091857.jpg
                    pageIndex:      int
                    linkedPages:    array - Always empty in current testing
                } ]
            }
        */
        getImageGalleryImages: async (folderName, imagesPerPage, currentPage) => await getJson("/api/Gallery/Private/" + userId + "/files?path=" + folderName + "&pagesize=" + imagesPerPage + "&page=" + (currentPage - 1), true),

        // renames a user gallery image
        /* no return data */
        renameImageGalleryImage: async (fileName, orderId, newName) => await putJson(
            "/api/Gallery/Private/" + userId + "/files/" + (orderId ? `${orderId}/` : "") + fileName + "?Name=" + encodeURIComponent(newName) + "&Path=" + (orderId || ""),
            null,
            true
        ),

        // deletes a user gallery image
        /* returns data in the following format:
            {   result:     bool - True if success
                fileName:   string - Original file name
            }
        */
        deleteImageGalleryImage: async (fileName, orderId) => await deleteJson(
            "/api/Gallery/Private/" + userId + "/files/" + (orderId ? `${orderId}/` : "") + fileName,
            null,
            true
        ),

    }),
);
